module.exports = __webpack_public_path__ + "static/img/page8-bg2.7d57d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page8-bg2.png
// module id = qYPH
// module chunks = 216